/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagLabPanelItem from './diag-lab-panel-item';
import DiagLabPanelItemDetail from './diag-lab-panel-item-detail';
import DiagLabPanelItemUpdate from './diag-lab-panel-item-update';
import DiagLabPanelItemDeleteDialog from './diag-lab-panel-item-delete-dialog';

const DiagLabPanelItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagLabPanelItem />} />
    <Route path="new" element={<DiagLabPanelItemUpdate />} />
    <Route path=":id">
      <Route index element={<DiagLabPanelItemDetail />} />
      <Route path="edit" element={<DiagLabPanelItemUpdate />} />
      <Route path="delete" element={<DiagLabPanelItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagLabPanelItemRoutes;
